const templates = {
  user: {
    civility: String(),
    lastName: String(),
    firstName: String(),

    status: Number(),
    funnel: Number(),
    customerStatus: Number(),

    avatar: String(),
    job: String(),

    address: {
      street: String(),
      city: String(),
      region: String(),
      country: String(),
      postalCode: String(),
    },

    phone: String(),
    email: String(),
    birthdate: new Date(),
    creationDate: new Date(),
    website: String(),
    bio: String(),
    siret: String(),

    contact: {
      call: false,
      mail: false,
      sms: false,
      preference: String(),
    },

    tva: {
      number: String(),
      status: false,
    },

    bankInfo: {
      bank: String(),
      country: String(),
      iban: String(),
    },

    company: String(),
    settings: {
      appTheme: "dark",
    },

    notification: {
      sync: {
        mail: false,
        app: false,
      },
      quote: {
        mail: false,
        app: true,
      },
      task: {
        mail: false,
        app: true,
      },
      team: {
        mail: false,
        app: true,
      },
      quota: {
        mail: false,
        app: true,
      },
    },

    otp: {
      active: false,
      secret: null,
      backupCodes: [],
    },
  },

  company: {
    siret: String(),

    nCompany: Number(),
    name: String(),

    status: Number(),
    customerStatus: Number(),

    address: {
      street: String(),
      city: String(),
      region: String(),
      country: String(),
      postalCode: String(),
    },

    avatar: String(),

    phone: String(),
    email: String(),
    creationDate: String(),
    birthdate: String(),
    website: String(),
    bio: String(),

    contact: {
      call: false,
      mail: false,
      sms: false,
      preference: String(),
    },

    tva: {
      number: String(),
      status: false,
    },

    bankInfo: {
      bank: String(),
      country: String(),
      iban: String(),
    },

    integrations: {},
  },

  project: {
    avatar: String(),
    content: String(),
    customers: [],
    due: String(),
    status: Number(),
    title: String(),
    type: String(),
    value: Number(),
  },

  task: {
    status: String(),
    task: String(),

    category: Number(),

    content: String(),

    priority: Number(),

    creationDate: new Date(),
    dueDate: "",

    author: String(),

    participants: [],

    project: String(),
    projectData: {},
  },

  product: {
    name: "",
    value: "",
    reference: "",
    taxRate: 20,
    discounts: [],

    shortDesc: "",
    longDesc: "",

    pictures: [
      {
        key: 0,
        link: "",
      },
      {
        key: 1,
        link: "",
      },
      {
        key: 2,
        link: "",
      },
      {
        key: 3,
        link: "",
      },
    ],
  },

  rank: {
    name: "",
    administration: false,
    enabled: true,
  },

  team: {
    name: "",
    description: "",
    logo: "",
  },

  quote: {
    belongTo: "",
    creationDate: new Date(),
    customer: "",
    discounts: [],
    dueDate: new Date(),
    nQuote: "",
    reference: "",
    remark: "",
    status: "",
    value: "",
    totals: {
      ht: 0,
      tax: 0,
      ttc: 0,
      byRate: [],
    },
  },

  invoice: {
    creationDate: new Date(),
    nInvoice: Number(),

    deliverDate: new Date(),

    customer: String(),

    quoteLinked: String(),

    tva: String(),

    discounts: [],

    payment: {
      dueDate: new Date(),
    },

    reference: String(),

    remark: String(),
    status: Number(),
    value: Number(),
    totals: {
      ht: 0,
      tax: 0,
      ttc: 0,
      byRate: [],
    },
    kind: "invoice",
    credited: null,
    cancelledAt: null,
    operationCategory: String(),
    vatRegime: String(),
    deliveryAddress: {
      street: String(),
      city: String(),
      region: String(),
      country: String(),
      postalCode: String(),
    },
    isDeliveryAddressDifferent: Boolean(),
  },

  blog: {
    id: String(),
    creationDate: new Date(),
    modificationDate: new Date(),
    name: String(),
  },

  blogArticle: {
    author: String(),
    modificationAuthor: String(),
    creationDate: new Date(),
    modificationDate: new Date(),

    title: String(),
    subTitle: String(),

    shortDesc: String(),
    longDesc: String(),

    disclaimer: String(),

    img: {
      main: String(),
      secondary: String(),
    },

    callToAction: "En savoir plus",

    contact: false,
  },

  remark: {
    creationDate: new Date(),
    author: String(),
    content: String(),
    type: String(),
    subject: String(),
  },

  module: {
    name: String(),
    description: String(),
  },

  warehouse: {
    name: String(),
    author: String(),
    creationDate: new Date(),
    authorData: {},
  },

  order: {
    creationDate: new Date(),

    status: Number(),
    stripeStatus: String(),
    orderPaid: Boolean(),

    customerId: String(),
    subscriptionId: String(),

    products: [],

    currency: String(),
    subtotal: Number(),
    total: Number(),
    totalDetails: {
      discount: Number(),
      shipping: Number(),
      tax: Number(),
    },
  },

  sellingPoint: {
    name: String(),
    type: String(),
    description: String(),
    creationDate: new Date(),
    author: String(),
  },
};

export const models = Object.defineProperties({}, Object.fromEntries(
  Object.keys(templates).map((key) => [key, {
    enumerable: true,
    get: () => structuredClone(templates[key]),
  }]),
));
